import { createContext } from 'react';

const IngredientContext = createContext();

export default IngredientContext
 